// ─── Store credentials ───────────────────────────────────────────────────────
var ShopApiUrl   = 'https://trainsweateat.myshopify.com/api/graphql';
var ShopApiToken = '3dfe9664eace609ab8a163ce89be4238';
var ShopFileUrl  = 'https://cdn.shopify.com/s/files/1/0654/6679/4196/files/';

// ─── GraphQL query ────────────────────────────────────────────────────────────
function buildQuery(type, cursor) {
  var after = cursor ? ', after: "' + cursor + '"' : '';
  return '{ products(first: 250, query: "product_type:\'' + type + '\'"' + after + ') { pageInfo { hasNextPage endCursor } edges { node { handle title tags priceRange { minVariantPrice { amount currencyCode } } compareAtPriceRange { minVariantPrice { amount } } featuredImage { url } images(first: 2) { edges { node { url } } } metafield0: metafield(namespace: "custom", key: "model") { value } metafield1: metafield(namespace: "custom", key: "color") { value } metafield2: metafield(namespace: "custom", key: "color_name") { value } metafield3: metafield(namespace: "custom", key: "sous_titre_produit") { value } metafield4: metafield(namespace: "theme", key: "badge") { value } variants(first: 100) { edges { node { availableForSale } } } } } } }';
}

// ─── File-based swatch image ──────────────────────────────────────────────────
function loadFileImageSrc(el) {
  if (!ShopFileUrl) return;
  var colorName = el.dataset.colorName;
  if (colorName) {
    var url = 'url("' + ShopFileUrl + colorName + '.jpg")';
    el.style.backgroundImage = url;
    var span = el.querySelector('span');
    if (span) span.style.backgroundImage = url;
  }
}

// ─── Overflow: hide extra swatches and show +N ────────────────────────────────
function applySwatchOverflow() {
  document.querySelectorAll('.product-card .color-selector').forEach(function(selector) {
    var links = selector.querySelector('.links');
    if (!links) return;

    var existing = links.querySelector('.more');
    if (existing) existing.remove();

    var allLinks = Array.from(links.querySelectorAll('a.color-variant'));
    allLinks.forEach(function(a) { a.style.display = ''; });

    var firstLink = allLinks[0];
    if (!firstLink) return;

    var swatchW = firstLink.getBoundingClientRect().width + parseFloat(getComputedStyle(firstLink).marginRight || 0);
    if (!swatchW) return;

    var limit = Math.floor(selector.offsetWidth / swatchW) - 1;
    var diff = allLinks.length - limit;

    if (diff >= 2) {
      var card = selector.closest('.product-card');
      var infoLink = card ? card.querySelector('.product-card__info') : null;
      var productUrl = infoLink ? infoLink.getAttribute('href') : '#';
      allLinks.slice(-diff).forEach(function(a) { a.style.display = 'none'; });
      links.insertAdjacentHTML('beforeend', '<a class="more" href="' + productUrl + '">+' + diff + '</a>');
    }
  });
}

// ─── Format money ─────────────────────────────────────────────────────────────
function formatMoney(amount, currencyCode) {
  var num = parseFloat(amount);
  var symbols = { EUR: '€', USD: '$', GBP: '£', CAD: 'CA$', CHF: 'CHF ' };
  var symbol = symbols[currencyCode] || (currencyCode + ' ');
  var formatted = num % 1 === 0 ? num.toFixed(0) : num.toFixed(2);
  // EUR/GBP: amount then symbol; USD: symbol then amount
  if (currencyCode === 'USD' || currencyCode === 'CAD') return symbol + formatted;
  return formatted + symbol;
}

// ─── Title-case color names ───────────────────────────────────────────────────
function titleCase(str) {
  return str.replace(/_/g, ' ').toLowerCase().replace(/\b\w/g, function(c) { return c.toUpperCase(); });
}

function applyColorTitleCase(root) {
  (root || document).querySelectorAll('.product-card__color, [data-color-name]').forEach(function(el) {
    if (el.textContent.trim()) el.textContent = titleCase(el.textContent);
  });
}

// ─── Swap card content in-place on swatch click ───────────────────────────────
function swapCardContent(card, data) {
  var productUrl = '/products/' + data.handle;

  card.querySelectorAll('a.product-card__info, a.product-card__media-link').forEach(function(a) {
    a.href = productUrl;
  });

  var quickAdd = card.querySelector('[data-quick-add]');
  if (quickAdd) quickAdd.dataset.quickAdd = data.handle;

  function setImgSrc(el, url) {
    var base = url.indexOf('?') !== -1 ? url.split('?')[0] + '?' + url.split('?')[1].split('&')[0] : url;
    el.src = base + '&width=600';
    el.srcset = [400, 600, 800, 1000].map(function(w) {
      return base + '&width=' + w + ' ' + w + 'w';
    }).join(', ');
  }

  if (data.image) {
    var img = card.querySelector('.product-card__img:not(.product-card__img--hover)');
    if (img) setImgSrc(img, data.image);
  }

  if (data.hoverImage) {
    var hoverImg = card.querySelector('.product-card__img--hover');
    if (hoverImg) setImgSrc(hoverImg, data.hoverImage);
  }

  var titleEl = card.querySelector('.product-card__title');
  if (titleEl && data.title !== undefined) titleEl.textContent = data.title;

  var subtitleEl = card.querySelector('.product-card__subtitle');
  if (subtitleEl && data.subtitle !== undefined) subtitleEl.textContent = data.subtitle;

  var colorEl = card.querySelector('.product-card__color');
  if (colorEl && data.colorName !== undefined) colorEl.textContent = titleCase(data.colorName);

  var priceEl = card.querySelector('.product-card__price');
  if (priceEl && data.price !== undefined) {
    var price        = parseFloat(data.price);
    var comparePrice = parseFloat(data.comparePrice || 0);
    var currency     = data.currency || 'EUR';
    if (comparePrice > price) {
      priceEl.innerHTML =
        '<del class="product-card__price-compare">' + formatMoney(comparePrice, currency) + '</del>' +
        '<ins class="product-card__price-sale">' + formatMoney(price, currency) + '</ins>';
    } else {
      priceEl.innerHTML = '<span>' + formatMoney(price, currency) + '</span>';
    }
  }

  var isSoldOut = data.available === 'false';
  card.classList.toggle('is-sold-out', isSoldOut);

  var extraBadgeEl = card.querySelector('.badge--extra');
  if (extraBadgeEl && !isSoldOut) {
    extraBadgeEl.textContent = data.badgeText || '';
  }
}

// ─── Swatch click handler (delegated) ────────────────────────────────────────
document.addEventListener('click', function(e) {
  var swatch = e.target.closest('.product-card .color-selector .color-variant');
  if (!swatch) return;
  e.preventDefault();

  var card = swatch.closest('.product-card');
  if (!card) return;

  card.querySelectorAll('.color-variant').forEach(function(a) { a.classList.remove('active'); });
  swatch.classList.add('active');

  swapCardContent(card, swatch.dataset);
});

// ─── Per-type request cache (in-memory only, resets on page load) ─────────────
var queryCache = {};

function fetchPage(type, cursor) {
  return fetch(ShopApiUrl, {
    method: 'POST',
    headers: {
      'X-Shopify-Storefront-Access-Token': ShopApiToken,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ query: buildQuery(type, cursor) })
  })
  .then(function(r) { return r.json(); })
  .then(function(data) {
    var products = data && data.data && data.data.products;
    if (!products) return { edges: [], hasNextPage: false, endCursor: null };
    return {
      edges: products.edges || [],
      hasNextPage: products.pageInfo.hasNextPage,
      endCursor: products.pageInfo.endCursor
    };
  });
}

function fetchAllByType(type, cursor, accumulated) {
  accumulated = accumulated || [];
  return fetchPage(type, cursor).then(function(page) {
    var all = accumulated.concat(page.edges);
    if (page.hasNextPage && page.endCursor) {
      return fetchAllByType(type, page.endCursor, all);
    }
    return all;
  });
}

function fetchByType(type) {
  if (queryCache[type]) return queryCache[type];
  queryCache[type] = fetchAllByType(type).catch(function() { return []; });
  return queryCache[type];
}

// ─── Build and inject swatches for one .color-selector element ────────────────
function searchProductsByType(elem) {
  var type          = elem.dataset.type;
  var model         = elem.dataset.model;
  var currentHandle = elem.dataset.productHandle;

  if (!type || !model) {
    elem.classList.add('ready');
    return;
  }

  elem.classList.add('ready');

  fetchByType(type)
  .then(function(edges) {
    var links = elem.querySelector('.links');

    edges.forEach(function(edge) {
      var product     = edge.node;
      var mModel      = (product.metafield0 && product.metafield0.value) || '';
      var mColor      = (product.metafield1 && product.metafield1.value) || '';
      var mColorName  = (product.metafield2 && product.metafield2.value) || '';
      var mSubtitle   = (product.metafield3 && product.metafield3.value) || '';
      var mBadge      = (product.metafield4 && product.metafield4.value) || '';
      var handle      = product.handle;
      var title       = (product.title || '').split(' - ')[0];
      var price       = product.priceRange && product.priceRange.minVariantPrice ? product.priceRange.minVariantPrice.amount : '';
      var currency    = product.priceRange && product.priceRange.minVariantPrice ? product.priceRange.minVariantPrice.currencyCode : 'EUR';
      var comparePrice = product.compareAtPriceRange && product.compareAtPriceRange.minVariantPrice ? product.compareAtPriceRange.minVariantPrice.amount : '0';
      var imageUrl      = product.featuredImage ? product.featuredImage.url : '';
      var hoverImageUrl = product.images && product.images.edges[1] ? product.images.edges[1].node.url : '';

      if (!handle || mModel !== model) return;

      var available = false;
      if (product.variants && product.variants.edges) {
        available = product.variants.edges.some(function(e) { return e.node.availableForSale; });
      }

      var badgeText = '';
      if (mBadge) {
        var w = mBadge.trim().toLowerCase();
        badgeText = w.charAt(0).toUpperCase() + w.slice(1);
      } else {
        var tags = product.tags || [];
        for (var ti = 0; ti < tags.length; ti++) {
          if (tags[ti].indexOf('_badge_') !== -1) {
            var bt = tags[ti].replace('_badge_', '').replace(/_/g, ' ').trim().toLowerCase();
            if (bt) { badgeText = bt.charAt(0).toUpperCase() + bt.slice(1); break; }
          }
        }
      }

      var spanStyle  = '';
      var outerStyle = '';
      var extraClass = '';
      var dataAttr   = '';

      if (mColor) {
        spanStyle  = 'background-color:' + mColor;
        outerStyle = 'background-color:' + mColor;
      } else if (mColorName) {
        extraClass = ' load-file-image';
        dataAttr = 'data-color-name="' + mColorName + '"';
      } else if (imageUrl) {
        spanStyle  = 'background-image:url(\'' + imageUrl + '&width=50\')';
        outerStyle = 'background-image:url(\'' + imageUrl + '&width=50\')';
      }

      var isActive   = handle === currentHandle ? ' active' : '';
      var isDisabled = !available ? ' disable' : '';

      var html = '<a href="/products/' + handle + '"' +
        ' class="color-variant' + extraClass + isActive + isDisabled + '"' +
        ' style="' + outerStyle + '"' +
        ' data-handle="' + handle + '"' +
        ' data-image="' + imageUrl + '"' +
        ' data-title="' + title.replace(/"/g, '&quot;') + '"' +
        ' data-subtitle="' + mSubtitle.replace(/"/g, '&quot;') + '"' +
        ' data-color-name="' + mColorName.replace(/"/g, '&quot;') + '"' +
        ' data-price="' + price + '"' +
        ' data-compare-price="' + comparePrice + '"' +
        ' data-currency="' + currency + '"' +
        ' data-available="' + available + '"' +
        ' data-hover-image="' + hoverImageUrl + '"' +
        ' data-badge-text="' + badgeText.replace(/"/g, '&quot;') + '"' +
        (dataAttr ? ' ' + dataAttr : '') +
        '><span style="' + spanStyle + '"></span></a>';

      if (available) {
        links.insertAdjacentHTML('afterbegin', html);
      } else {
        links.insertAdjacentHTML('beforeend', html);
      }
    });

    elem.querySelectorAll('.color-variant.load-file-image').forEach(loadFileImageSrc);
  });
}

// ─── Init ─────────────────────────────────────────────────────────────────────
function loopSearchProductsByType() {
  document.querySelectorAll('.color-selector:not(.ready)').forEach(searchProductsByType);
}

document.addEventListener('DOMContentLoaded', function() {
  loopSearchProductsByType();
  applyColorTitleCase();
});

// Initialize swatches and title case for cards injected after page load (e.g. Nosto)
new MutationObserver(function(mutations) {
  mutations.forEach(function(m) {
    m.addedNodes.forEach(function(node) {
      if (node.nodeType !== 1) return;
      applyColorTitleCase(node);
      node.querySelectorAll('.color-selector:not(.ready)').forEach(searchProductsByType);
    });
  });
}).observe(document.body, { childList: true, subtree: true });

